import { FC } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import config from 'config';

import GuestLayout from '../GuestLayout/GuestLayout';
import GuestDocumentsPage from '../GuestDocumentsPage/GuestDocumentsPage';

const GuestApp: FC = () => (
    <GuestLayout>
        <Switch>
            <Route path={config.routes.guestDocuments} exact render={() => <GuestDocumentsPage />} />
            <Route render={() => <Redirect to={config.routes.guestDocuments} />} />
        </Switch>
    </GuestLayout>
);

export default GuestApp;
